import { apiClient } from './api';

/**
 * Initialize Payment Request DTO
 */
export interface InitializePaymentRequest {
  currency: string;
  enabledInstallments?: number[];
  buyer: {
    name: string;
    surname: string;
    email: string;
    identityNumber?: string;
    registrationAddress: string;
    city: string;
    country: string;
    ip?: string;
  };
  shippingAddress: {
    contactName: string;
    city: string;
    country: string;
    address: string;
  };
  billingAddress: {
    contactName: string;
    city: string;
    country: string;
    address: string;
  };
  saveCard?: boolean;
  addressId?: string;
  notes?: string;
  desiredDeliveryTime?: string;
  customerFullName?: string;
  customerPhone?: string;
  customerEmail?: string;
  deliveryLatitude?: number;
  deliveryLongitude?: number;
  deliveryAddressText?: string;
}

/**
 * Initialize Payment Response
 */
export interface InitializePaymentResponse {
  paymentId: string;
  token: string;
  paymentPageUrl: string;
  amount: number;
  currency: string;
}

/**
 * Verify Payment Response
 */
export interface VerifyPaymentResponse {
  success: boolean;
  orderId?: string;
  orderNumber?: string;
  error?: string;
}

/**
 * Payment Service
 * 
 * Handles payment initialization with Iyzico and payment verification
 */
export const paymentService = {
  /**
   * Initialize payment with Iyzico
   * 
   * Returns payment page URL for redirect
   */
  async initializePayment(data: InitializePaymentRequest): Promise<InitializePaymentResponse> {
    const response = await apiClient.post<InitializePaymentResponse>('/payments/initialize', data);
    return response.data.data;
  },

  /**
   * Verify payment token and get order details
   * 
   * Called after redirect from Iyzico to verify payment status
   */
  async verifyPayment(token: string): Promise<VerifyPaymentResponse> {
    try {
      const response = await apiClient.post<{ orderId: string; orderNumber: string }>(
        '/orders/verify-payment',
        { token }
      );
      return {
        success: true,
        orderId: response.data.data.orderId,
        orderNumber: response.data.data.orderNumber,
      };
    } catch (err: any) {
      const errorMessage =
        err.response?.data?.error?.message ||
        err.message ||
        'Ödeme doğrulaması başarısız oldu.';
      return {
        success: false,
        error: errorMessage,
      };
    }
  },
};
